import type React from 'react';
export function StatCard({
  icon, value, label, accent,
}: {
  icon: React.ReactNode;
  value: number | string;
  label: string;
  accent: 'forest' | 'info' | 'saffron';
}) {
  const colorMap = {
    forest: { bg: 'var(--forest-50)', fg: 'var(--forest-600)', border: 'var(--forest-100)' },
    info:   { bg: 'var(--info-bg)',   fg: 'var(--info)',       border: '#C7D9E5' },
    saffron:{ bg: 'var(--saffron-50)', fg: 'var(--saffron-600)', border: 'var(--saffron-100)' },
  }[accent];

  return (
    <div className="card" style={{ padding: 16 }}>
      <div className="row gap-3 center">
        <div
          style={{
            width: 36, height: 36,
            borderRadius: 'var(--r-sm)',
            background: colorMap.bg,
            border: `1px solid ${colorMap.border}`,
            color: colorMap.fg,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          {icon}
        </div>
        <div>
          <div
            style={{
              fontFamily: 'var(--ff-serif)',
              fontSize: 22,
              fontWeight: 500,
              color: 'var(--ink-0)',
              letterSpacing: -0.02,
              lineHeight: 1.1,
            }}
          >
            {value}
          </div>
          <div className="kpi-label">{label}</div>
        </div>
      </div>
    </div>
  );
}
